export const AGG = { rating: 4.9, count: 27 };

export const REVIEWS = [
  { name: "Sarah H.", area: "Mumbles, SA3", rating: 5, text: "Absolutely brilliant. Mounted our 55\" TV and tidied all the cables in under two hours. Punctual, tidy and great value. Wouldn't use anyone else in Mumbles." },
  { name: "Dai R.", area: "Sketty, SA2", rating: 5, text: "Assembled two IKEA PAX wardrobes that had been sat in boxes for months. Spot on, level and anchored to the wall. Cleared all the packaging too. Top job." },
  { name: "Megan L.", area: "Uplands, SA2", rating: 5, text: "Repainted our hallway and living room beautifully. Really careful prep and crisp lines. You'd never know we had a decorator in — no mess at all." },
  { name: "Tom J.", area: "Gower, SA3", rating: 5, text: "Storm took out three fence panels. Fit N Fix had them replaced and rock solid within a couple of days. Fair price, proper job. Highly recommend." },
  { name: "Priya K.", area: "Morriston, SA6", rating: 5, text: "Gutters were overflowing every time it rained. Cleared and flushed the downpipes, no more damp patch. Friendly, reliable and honest pricing." },
  { name: "Gareth M.", area: "Killay, SA2", rating: 4, text: "Had a whole list of odd jobs — shelves, a sticky door and a leaking seal round the bath. All sorted in one visit. Great to have a proper local handyman." },
];

// Illustrative stock before/after pairs — replace with your own job photos anytime.
export const BEFORE_AFTER = [
  {
    title: "Living Room Repaint",
    area: "Sketty, SA2",
    before: "https://images.unsplash.com/photo-1444419988131-046ed4e5ffd6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
    after: "https://images.unsplash.com/photo-1633330977020-2bdfb8530cc2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
  {
    title: "New Fence Panels",
    area: "Gower, SA3",
    before: "https://images.pexels.com/photos/18900649/pexels-photo-18900649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
    after: "https://images.unsplash.com/photo-1601042860368-debed90085e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
  {
    title: "Kitchen Refresh",
    area: "Mumbles, SA3",
    before: "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
    after: "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
];
